import ScrollAware from './scroll-aware';
import type { JSX } from 'react';
import { useAppSelector } from '~/store/types';
import { selectIsDesktop } from '~/components/brand/ducks/selectors';

type Props = {
	children: (scrollYPosition: number) => JSX.Element;
};

/**
 * Used for responsive where the sidebar element is mounted.
 * If it is not found, the sidebar position returned will be 0.
 *
 * @param {Object} props - Component props.
 * @param {Function} props.children - A function that receives scroll-related props to render the content.
 * @returns {JSX.Element}
 */
const SidebarScrollAware = ({ children }: Props) => {
	const isDesktop = useAppSelector(selectIsDesktop);
	// Finds the sidebar element that scrolls it's content
	// A custom scrollbar is used on desktop which adds a couple
	// of nested divs where the last one is the scrolling one.
	const scrollingElement = isDesktop
		? document.querySelector('#sidebar > div > div')
		: document.getElementById('sidebar'); // FIXME_SIDEBAR

	return (
		<ScrollAware scrollingContainer={scrollingElement}>{scrollYPosition => children(scrollYPosition)}</ScrollAware>
	);
};

export default SidebarScrollAware;
